import { gql } from "@apollo/client";

const GET_DOMAINS = gql`
  query GetDomains {
    domains {
      nodes {
        id
        name
      }
    }
  }
`;

export { GET_DOMAINS };
